import React, {useState, useEffect, useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {Redirect} from 'react-router-dom';

import "./UserProfile.css";
import axios from "../../axios/axiosdb"
import Posts from "../../components/Posts/Posts";
import * as actions from "../../store/actions";

const UserProfile = (props) => {

    const [userData, setUserData] = useState({})
    const [loading, setLoading] = useState(false)

    const authUserId = useSelector(state => state.auth.userId)
    const userPosts = useSelector(state => state.post.posts)
    const postLoading = useSelector(state => state.post.loading)

    const dispatch = useDispatch()
    const getPosts = useCallback((url, queryParams) => dispatch(actions.post(url, queryParams)), [dispatch])

    const userId = new URLSearchParams(props.location.search).get("userId")
    const isAuthUserProfile = userId === authUserId

    useEffect(() => {
        setLoading(true)
        // For resetting the posts data
        dispatch(actions.postInit())
        axios
            .get("/users/" + userId + ".json")
            .then(response => {
                const userData = {
                    email: response.data.email,
                    username: response.data.username,
                    createdOn: response.data.createdOn
                }
                setUserData(userData)
                setLoading(false)
            })
            .catch(error => {
                console.log(error)
                setLoading(false)
            })

    }, [userId, dispatch])

    useEffect(() => {
        if (userData.username)
            document.title = "Profile: " + userData.username + " | Hacker News clone"
    }, [userData])


    const getUserPost = () => {
        const url = "/userposts/" + userId + ".json"
        getPosts(url, "")
    }

    return (
        <div className="UserProfile">
            {!userId ? <Redirect to="/"/> : null}
            {loading ?
                "Loading..."
                :
                <>
                    <table>
                        <tbody>
                        <tr>
                            <td>email:</td>
                            <td>{userData.email}</td>
                        </tr>
                        <tr>
                            <td>username:&nbsp;&nbsp;&nbsp;</td>
                            <td>{userData.username}</td>
                        </tr>
                        <tr>
                            <td>created:</td>
                            <td>{userData.createdOn}</td>
                        </tr>
                        </tbody>
                    </table>
                    <p onClick={getUserPost}>see all {isAuthUserProfile ? "your" : userData.username} post</p>

                </>
            }
            {postLoading ? "Loading..." : null}
            <Posts postData={userPosts}/>
        </div>
    )
}

export default UserProfile;